/**
 * Device data and user activity models
 */
/**
 * Device operating modes for Bluetooth data collection
 */
export var DeviceMode;
(function (DeviceMode) {
    DeviceMode[DeviceMode["Idle"] = 0] = "Idle";
    DeviceMode[DeviceMode["Calibration"] = 1] = "Calibration";
    DeviceMode[DeviceMode["Patient"] = 2] = "Patient";
})(DeviceMode || (DeviceMode = {}));
/**
 * Helper functions for DeviceData
 */
export class DeviceDataHelper {
    static isTemperatureValid(statusBits) {
        return (statusBits & 0x02) !== 0; // Bit 1
    }
    static isPhValid(statusBits) {
        return (statusBits & 0x04) !== 0; // Bit 2
    }
    static isBatteryValid(statusBits) {
        return (statusBits & 0x08) !== 0; // Bit 3
    }
    static convertToDeviceDataRow(packet, deviceId, userId) {
        return {
            device_id: deviceId,
            user_id: userId,
            temperature_raw: packet.temperatureRaw,
            ph_voltage_mv: packet.phVoltageRaw,
            battery_voltage_mv: packet.batteryVoltage,
            device_timestamp: packet.deviceTimestamp,
            status_bits: packet.statusBits,
            sequence_number: packet.sequenceNumber,
            mode: packet.mode,
            recorded_at: packet.receivedAt
        };
    }
}
